import {useQuery} from "@tanstack/react-query";
import {gql, request} from "graphql-request";

export const GET_TARGETS = gql`
	query GetTargets($fiscal_year: Int!, $targets: [String]!) {
		get_targets(fiscal_year: $fiscal_year, targets: $targets) {
			site_number
			period
			fiscal_year
			target_name
			target_value
		}
	}
`;

export interface Target {
	site_number: number;
	period: string;
	fiscal_year: number;
	target_name: string;
	target_value: number;
}

export interface GetTargetsResponse {
	get_targets: Target[];
}

export const useGetTargets = (
	brand?: string,
	fiscal_year?: number,
	targets?: string[]
) => {
	const endpoint =
		brand === "cleanfreak"
			? process.env.REACT_APP_GRAPHQL_API_URL_CLEANFREAK
			: brand === "rainstorm"
			? process.env.REACT_APP_GRAPHQL_API_URL_RAINSTORM
			: undefined;

	return useQuery<GetTargetsResponse>({
		queryKey: ["get_targets", brand, fiscal_year, targets],
		queryFn: async (): Promise<GetTargetsResponse> => {
			if (!endpoint) throw new Error("Missing GraphQL endpoint");

			const variables: Record<string, any> = {
				fiscal_year,
				targets,
			};

			const data = await request<GetTargetsResponse>(
				endpoint,
				GET_TARGETS,
				variables
			);

			return data;
		},
		enabled: !!endpoint && !!fiscal_year && !!targets,
	});
};
